export default "<div>\r\n  Footer\r\n</div>\r\n"